import React, { useState, useEffect } from 'react';
import Select from "react-select";
import { get_address, edit_addresses } from '../../api/Product';
import Country_State_Data from '../country_state_data/Country_State_Data';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const Edit_Billing_Address = () => {
    const navigate = useNavigate()
    const get_user_data = localStorage.getItem("user");
    const parsedUserData = JSON.parse(get_user_data);
    console.log("User Email:", parsedUserData?.name);

    const [formData, setFormData] = useState({
        id: null,
        type: "billing",
        fullName: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        phone: '',
        email: parsedUserData?.email || '',
    });

    const [stateOptions, setStateOptions] = useState([]);
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" };

    // Convert country options for react-select
    const countryOptions = Object.entries(Country_State_Data).map(([code, details]) => ({
        value: code,
        label: details.name,
    }));

    // Fetch Address List when component mounts
    useEffect(() => {
        const fetchAddressList = async () => {
            try {
                const response = await get_address(headers);
                console.log("Fetched Address List:", response?.data);
                const lastBillingAddress = response?.data?.find(item => item?.type === "billing");
                if (lastBillingAddress) {
                    setFormData({
                        id: lastBillingAddress.id,
                        fullName: lastBillingAddress.fullName || '',
                        address: lastBillingAddress.address || '',
                        city: lastBillingAddress.city || '',
                        zip: lastBillingAddress.zip || '',
                        phone: lastBillingAddress.phone || '',
                        email: lastBillingAddress.email || parsedUserData?.email || '',
                        country: countryOptions.find(c => c.value === lastBillingAddress.country) || '',
                        state: lastBillingAddress.state || ''
                    });

                    updateStateOptions(lastBillingAddress.country);
                }
            } catch (error) {
                console.error("Error fetching addresses:", error);
            }
        };

        fetchAddressList();
    }, []);

    // Update state options based on selected country
    const updateStateOptions = (countryCode) => {
        const states = Country_State_Data[countryCode]?.states || [];
        setStateOptions(states.map(state => ({ value: state, label: state })));
    };

    // Handle input change
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Handle Country Selection
    const handleCountryChange = (selectedOption) => {
        setFormData({ ...formData, country: selectedOption, state: '' });
        updateStateOptions(selectedOption.value);
    };

    // Handle State Selection
    const handleStateChange = (selectedOption) => {
        setFormData({ ...formData, state: selectedOption });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        const formDataToSend = new FormData();

        Object.entries(formData).forEach(([key, value]) => {
            if (typeof value == "object" && value !== null && "value" in value) {
                formDataToSend.append(key, value.value);  // Extract value if it's an object
            } else {
                formDataToSend.append(key, value);
            }
        });

        if (!formData.id) {
            console.error("Address ID is missing");
            return;
        }

        try {
            const response = await edit_addresses(formData.id, formDataToSend, headers);
            console.log("Edit API Response:", response);
            toast.success("Billing address updated successfully!");
            setTimeout(() => {
                navigate("/my-account")
            }, 1500)
        } catch (error) {
            console.error("Error updating address:", error);
        }
    };


    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
            {/* <-------- ToastContainer ------------> */}
            <ToastContainer style={{ marginTop: "120px" }} />
            <div className="bg-white shadow-md rounded-lg w-full max-w-lg">
                <div className="px-6 py-4 border-b">
                    <h2 className="text-2xl font-bold text-gray-800">Edit Billing Address</h2>
                </div>
                <form className="px-6 py-4" onSubmit={handleSubmit}>

                    {/* Email */}
                    <div className="mb-4">
                        <label htmlFor="email" className="block text-gray-700 mb-2">Email address</label>
                        <input type="text" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:border-amber-300" />
                    </div>

                    {/* Full Name */}
                    <div className="mb-4">
                        <label htmlFor="fullName" className="block text-gray-700 mb-2">Full Name</label>
                        <input type="text" id="fullName" name="fullName" value={parsedUserData?.name} onChange={handleChange} required className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:border-amber-300" />
                    </div>

                    {/* Address */}
                    <div className="mb-4">
                        <label htmlFor="address" className="block text-gray-700 mb-2">Address</label>
                        <input type="text" id="address" name="address" value={formData.address} onChange={handleChange} required className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:border-amber-300" />
                    </div>

                    {/* Country Dropdown */}
                    <div className="mb-4">
                        <label className="block text-gray-700 mb-2">Country *</label>
                        <Select options={countryOptions} value={formData.country} onChange={handleCountryChange} placeholder="Select a country..." />
                    </div>

                    {/* State Dropdown */}
                    {stateOptions.length > 0 && (
                        <div className="mb-4">
                            <label className="block text-gray-700 mb-2">State *</label>
                            <Select options={stateOptions} value={formData.state} onChange={handleStateChange} placeholder="Select a state..." />
                        </div>
                    )}

                    {/* ZIP Code and City */}
                    <div className="mb-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label htmlFor="zip" className="block text-gray-700 mb-2">ZIP Code</label>
                            <input type="text" id="zip" name="zip" value={formData.zip} onChange={handleChange} required className="w-full px-3 py-2 border rounded-md" />
                        </div>
                        <div>
                            <label htmlFor="city" className="block text-gray-700 mb-2">City</label>
                            <input type="text" id="city" name="city" value={formData.city} onChange={handleChange} required className="w-full px-3 py-2 border rounded-md" />
                        </div>
                    </div>

                    {/* Phone */}
                    <div className="mb-4">
                        <label htmlFor="phone" className="block text-gray-700 mb-2">Phone Number</label>
                        <input type="number" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-3 py-2 border rounded-md" />
                    </div>

                    {/* Save Button */}
                    <div className="flex justify-end">
                        <button type="submit" className="bg-amber-600 text-white px-6 py-2 rounded-md hover:bg-amber-700">Save Address</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Edit_Billing_Address;
